import React, { useAppContext } from "../../context/appContext";
import { PriceBox } from "./PriceTablesParts";
import { numberToMoney } from "../../utils/money";
import { calcCost } from "../../utils/calcCost";

const SkylightCosts = ({ title, columnName, priceTable, costTable, pricePackage }) => {
  const { prices, lists } = useAppContext();

  const { priceSheet, formerPriceSheet, handleInput, enableEdits, handleKeyDown, showPrevious } =
    pricePackage;
  const inputPackage = {
    handleInput,
    enableEdits,
    handleKeyDown,
    priceTable: costTable,
    showPrevious,
  };

  const laborCost = prices["laborPrices"]?.filter(
    (price) => price.price_sheets_id === parseInt(priceSheet)
  )[0].labor_cost;

  const sizeSort = (a, b) => {
    if (priceTable === "extrasPrices") {
      const sizeList = lists.listExtras.map((item) => item.id);
      const aRank = sizeList.indexOf(a.extras_id);
      const bRank = sizeList.indexOf(b.extras_id);
      return aRank - bRank;
    } else {
      const sizeList = lists?.listSkylightSizes.map((size) => size.text);
      const aRank = sizeList?.indexOf(a.size || a.diameter);
      const bRank = sizeList?.indexOf(b.size || b.diameter);
      return aRank - bRank;
    }
  };

  const priceArray = prices[priceTable]
    ?.filter((price) => price.price_sheets_id === parseInt(priceSheet))
    .sort((a, b) => sizeSort(a, b));

  const formerPriceArray = prices[priceTable]
    ?.filter((price) => price.price_sheets_id === parseInt(formerPriceSheet))
    .sort((a, b) => sizeSort(a, b));

  const costArray = prices[costTable]
    ?.filter((price) => price.price_sheets_id === parseInt(priceSheet))
    .sort((a, b) => sizeSort(a, b));

  const formerCostArray = prices[costTable]
    ?.filter((price) => price.price_sheets_id === parseInt(formerPriceSheet))
    .sort((a, b) => sizeSort(a, b));

  return (
    <div className="skylight-costs">
      <h4>{title}</h4>
      <table>
        <tbody>
          <tr>
            <th>{priceTable !== "extrasPrices" ? "Size" : "Item"}</th>
            <th>Unit Cost</th>
            <th>Retail</th>
            <th>Tax</th>
            <th>{`Man Hours ($${laborCost})`}</th>
            <th>Total Cost</th>
            <th>Listed Price</th>
            <th>Est. Profit</th>
          </tr>
          {costArray.map((costRow, index) => {
            const listPrice = priceArray[index][columnName];
            const formerPrice = formerPriceArray[index] && formerPriceArray[index][columnName];
            const formerCostRow = formerCostArray[index];

            const { tax, totalCost, profit } = calcCost(costRow, columnName, laborCost, listPrice);
            const {
              // tax: formerTax,
              // totalCost: formerTotalCost,
              profit: formerProfit,
            } = calcCost(costRow, columnName, laborCost, listPrice);

            // console.log("formerPrice:", formerPrice);
            // console.log("formerCostRow:", formerCostRow);

            return (
              <tr key={costRow.id}>
                <td width="60">{costRow.size || costRow.diameter || costRow.item}</td>
                <PriceBox
                  index={index}
                  priceName={columnName + "_materials"}
                  value={costRow[columnName + "_materials"]}
                  previousValue={formerCostRow && formerCostRow[columnName + "_materials"]}
                  inputPackage={inputPackage}
                />
                <PriceBox
                  index={index}
                  priceName={columnName + "_retail"}
                  value={costRow[columnName + "_retail"]}
                  previousValue={formerCostRow && formerCostRow[columnName + "_retail"]}
                  inputPackage={inputPackage}
                />
                <td>{numberToMoney(tax)}</td>
                <PriceBox
                  index={index}
                  priceName={columnName + "_labor"}
                  value={costRow[columnName + "_labor"]}
                  previousValue={formerCostRow && formerCostRow[columnName + "_labor"]}
                  inputPackage={inputPackage}
                />
                <td>{numberToMoney(totalCost)}</td>
                <PriceBox
                  index={index}
                  priceName={columnName}
                  value={listPrice}
                  previousValue={formerPrice}
                  inputPackage={{ ...inputPackage, priceTable }}
                />
                <td>
                  {numberToMoney(profit)}
                  {showPrevious && (
                    <span className="previous-price">{numberToMoney(formerProfit) || 0}</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const SkylightCostBlock = (priceTable, pricePackage) => {
  return (
    <>
      <SkylightCosts
        title="Domes Only"
        columnName="domes_only"
        priceTable={priceTable}
        costTable="skylightCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="Curb Mount Mill Frame"
        columnName="with_mill"
        priceTable={priceTable}
        costTable="skylightCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="Curb Mount Bronze Frame"
        columnName="with_bronze"
        priceTable={priceTable}
        costTable="skylightCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="Self Flashing Mill Frame"
        columnName="sf_mill"
        priceTable={priceTable}
        costTable="skylightCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="Self Flashing Bronze Frame"
        columnName="sf_bronze"
        priceTable={priceTable}
        costTable="skylightCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="FCM Velux Clear"
        columnName="velux_clear"
        priceTable={priceTable}
        costTable="skylightCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="FCM Velux White"
        columnName="velux_white"
        priceTable={priceTable}
        costTable="skylightCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="FS Velux Clear"
        columnName="sf_velux"
        priceTable={priceTable}
        costTable="skylightCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="Reflashes"
        columnName="reflash"
        priceTable={priceTable}
        costTable="skylightCosts"
        pricePackage={pricePackage}
      />
    </>
  );
};

const MiscPriceBlock = (pricePackage) => {
  return (
    <>
      <SkylightCosts
        title="Residential Sun Tunnels"
        columnName="tunnel"
        priceTable="sunTunnelPrices"
        costTable="sunTunnelCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="Roofer Sun Tunnels"
        columnName="tunnel"
        priceTable="rooferSunTunnelPrices"
        costTable="sunTunnelCosts"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="Line Items"
        columnName="price"
        priceTable="extrasPrices"
        costTable="extrasPrices"
        pricePackage={pricePackage}
      />
      <SkylightCosts
        title="Attic Vents"
        columnName="price"
        priceTable="ventPrices"
        costTable="ventPrices"
        pricePackage={pricePackage}
      />
    </>
  );
};

export { MiscPriceBlock, SkylightCostBlock };
